// src/config.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_SERVER_DOMAIN;

export default {
  REACT_APP_SERVER_DOMAIN: BASE_URL
};

/**
 * Client HTTP authentifié, utilisé par la feuille de dépense (livreur) et
 * l'écran de validation (secrétaire).
 *
 * ⚠ IL LISAIT LE JETON UNE SEULE FOIS, AU CHARGEMENT DU MODULE :
 *
 *     const TOKEN = currentUser?.accessToken;
 *     axios.create({ headers: { token: `Bearer ${TOKEN}` } })
 *
 * Une instance créée par `axios.create` n'hérite PAS des intercepteurs de
 * l'instance axios par défaut : celle-ci portait donc, jusqu'au prochain
 * rechargement complet de la page, le jeton figé au démarrage. Trois
 * conséquences, toutes vécues sur un téléphone de livraison :
 *   - l'app Android est une WebView qui vit des heures sans rechargement ;
 *   - sur un téléphone partagé, le jeton du collègue précédent restait actif
 *     après une reconnexion ;
 *   - si l'écran était chargé avant la connexion, l'en-tête valait
 *     « Bearer undefined » et toutes les requêtes partaient sans jeton.
 *
 * Le jeton est désormais relu À CHAQUE REQUÊTE, comme le fait l'intercepteur
 * global de l'instance par défaut. Même export, même `baseURL` : les appels
 * existants (chemins relatifs) ne changent pas.
 */
const lireJeton = () => {
  try {
    const brut = localStorage.getItem("persist:root");
    if (!brut) return null;
    const user = JSON.parse(brut)?.user;
    const currentUser = user && JSON.parse(user).currentUser;
    return currentUser?.accessToken || null;
  } catch (e) {
    // localStorage illisible (mode privé, quota, JSON corrompu) : on part sans
    // jeton plutôt que de faire planter l'écran au montage.
    return null;
  }
};

export const userRequest = axios.create({ baseURL: BASE_URL });

userRequest.interceptors.request.use((cfg) => {
  const jeton = lireJeton();
  if (jeton) cfg.headers.token = `Bearer ${jeton}`;
  else delete cfg.headers.token;
  return cfg;
});
